import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewVersionRemixInputFieldName =
  'remix_name'|'remix_name_kana'|'remix_name_en'|
  'remixer_name'|'remixer_name_en';

/**
 * バージョン入力（リミックス）
 */
export default function MusicAlbumEditForm3EditPopupViewVersionRemixInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: MusicAlbumEditForm3EditPopupViewVersionRemixInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewVersionRemixInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewVersionRemixInputFieldName) => FieldValidationErrorsType,
}) {
  return (
    <>
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">リミックス名</label>
        </dt>
        <dd>
          <CustomTextInput
            placeholder=""
            value={getValue('remix_name')}
            setValue={(value) => setValue('remix_name', value)}
            validationErrors={getErrors('remix_name')}
          />
          <p className="text_info_off">ここに説明文</p>
        </dd>
      </dl>
      <dl>
        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
        <dt><label htmlFor="/">リミックス名（ひらがな）</label></dt>
        <dd>
          <CustomTextInput
            placeholder=""
            value={getValue('remix_name_kana')}
            setValue={(value) => setValue('remix_name_kana', value)}
            validationErrors={getErrors('remix_name_kana')}
          />
          <p className="text_info_off">ここに説明文</p>
        </dd>
      </dl>
      <dl>
        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
        <dt><label htmlFor="/">リミックス名（英語）</label></dt>
        <dd>
          <CustomTextInput
            placeholder=""
            value={getValue('remix_name_en')}
            setValue={(value) => setValue('remix_name_en', value)}
            validationErrors={getErrors('remix_name_en')}
          />
          <p className="text_info_on">「Album」「Single」「Limited」等、販売形式を限定するような表現は使用できません。</p>
        </dd>
      </dl>    
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">リミキサー名</label>
        </dt>
        <dd>
          <CustomTextInput
            placeholder=""
            value={getValue('remixer_name')}
            setValue={(value) => setValue('remixer_name', value)}
            validationErrors={getErrors('remixer_name')}
          />
          <p className="text_info_off">ここに説明文</p>
        </dd>
      </dl>
      <dl>
        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
        <dt><label htmlFor="/">リミキサー名（英語）</label></dt>
        <dd>
          <CustomTextInput
            placeholder=""
            value={getValue('remixer_name_en')}
            setValue={(value) => setValue('remixer_name_en', value)}
            validationErrors={getErrors('remixer_name_en')}
          />
          <p className="text_info_off">ここに説明文</p>
        </dd>
      </dl>
    </>
  );
}
